import {functionality} from './functionality';
import {packCountryDomain} from './packCountryDomain';

export const packCountryDomainFunctionality = function (item = null) {
    return {
        id: item == null ? 0 : item.id,
        value: item == null ? '0' : item.value,
        functionality: item == null ? functionality() : item.functionality,
        isDisplayed: item == null ? false : item.isDisplayed,
        packCountryDomain: item == null ? packCountryDomain() : item.packCountryDomain
    };
};
